import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatSort, MatTableDataSource} from '@angular/material';
import {HttpClient} from '@angular/common/http';
import {forkJoin} from 'rxjs';
import {DecimalPipe} from '@angular/common';
import {CurrencyType} from '../table-view/table-view.service';
import {CurrencyService} from '../../services/currency.service';


@Component({
    selector: 'app-change-currency-dialog',
    templateUrl: './change-currency-dialog.component.html',
    styleUrls: ['./change-currency-dialog.component.css']
})
export class ChangeCurrencyDialogComponent implements OnInit {

    public selectedOutputCurrency: CurrencyType = this.currencyService.selectedCurrency;
    public countriesDataSource = new MatTableDataSource([]);
    public displayedColumns: string[] = ['country', 'input_currency', 'calculated_value', 'source'];

    rates = [];
    countries = [];

    @ViewChild(MatSort, {static: false}) sort: MatSort;

    constructor(
        @Inject(MAT_DIALOG_DATA) public availableCountries: Set<string>,
        public dialogRef: MatDialogRef<ChangeCurrencyDialogComponent>,
        private http: HttpClient,
        private currencyService: CurrencyService,
        private decimal: DecimalPipe) {
    }

    ngOnInit() {
        this.selectedOutputCurrency = this.currencyService.selectedCurrency;

        this.countriesDataSource.sort = this.sort;

        const ratesRequest = this.http.post('/getcurrencyrates/', {});
        const countryCodesRequest = this.http.post('/getcurrencyrates/', {option: 'iso'});


        forkJoin([
            ratesRequest,
            countryCodesRequest
        ]).subscribe((result: any[]) => {
            this.rates = result[0];
            this.countries = result[1];

          this.onCurrencyUpdate();

          // if (this.currencyService.mergedData.length === 0) {
          //   } else {
          //       this.countriesDataSource.data = this.currencyService.mergedData;
          //   }
        });
    }

    public onCurrencyUpdate() {
        this.countriesDataSource.data = this.mergeRatesWithCountries(this.rates, this.countries);
        this.currencyService.mergedData = this.countriesDataSource.data;
    }

    private mergeRatesWithCountries(rates: Array<any>, countries: Array<any>): any[] {
        const result = [];

        countries = countries.filter(country => {
            return this.availableCountries.has(country['Country_name']);
        });

        countries.forEach(country => {
            const rate = rates.find(r => r['Currency_from_cd'] === country['Currency_code']);

            if (rate) {
                const ratio = this.convertToCurrencySelected(rate);

                result.push({
                    Country_name: country['Country_name'],
                    Currency_code: country['Currency_code'],
                    source: this.extractSourceForSelectedLanguage(rate),
                    ratio: ratio,
                    price: this.decimal.transform(ratio, '1.8-8')
                });
            }
        });
        this.sortCountriesByCurrency(result);

        return result;
    }

    private sortCountriesByCurrency(result) {
        result.sort((a, b) => {
            if (a.Country_name < b.Country_name) {
                return -1;
            }

            if (a.Country_name > b.Country_name) {
                return 1;
            }

            return 0;
        });
    }

    public onDoneClicked() {
        this.dialogRef.close({
            option: this.selectedOutputCurrency,
            data: this.countriesDataSource.data
        });
    }

    public onChangeBackToLCU() {
        this.currencyService.mergedData = [];

        this.dialogRef.close({
            option: CurrencyType.NONE
        });
    }

    public onRateValueChanged($event, row) {
        if ($event) {
            row['price'] = $event;
            row['ratio'] = Number($event);
        }
    }

    public onSourceValueChanged($event, row) {
        if ($event) {
            row['source'] = $event;
        }
    }

    private extractSourceForSelectedLanguage(rate) {
        if (!rate) {
            return '';
        }

        let key;
        switch (this.selectedOutputCurrency) {
            case 0:
                key = 'Conv_to_CHF_source';
                break;
            case 1:
                key = 'Conv_to_EUR_source';
                break;
            case 2:
                key = 'Conv_to_GBP_source';
                break;
            case 3:
                key = 'Conv_to_USD_source';
                break;
        }

        if (rate.hasOwnProperty(key)) {
            return rate[key];
        }
        return '';
    }

    private convertToCurrencySelected(rate) {
        const currencyValue = this.extractRateForSelectedCurrency(rate);
        return 1 / currencyValue;
    }

    private extractRateForSelectedCurrency(rate) {
        let key;
        switch (this.selectedOutputCurrency) {
            case 0:
                key = 'Conv_to_CHF';
                break;
            case 1:
                key = 'Conv_to_EUR';
                break;
            case 2:
                key = 'Conv_to_GBP';
                break;
            case 3:
                key = 'Conv_to_USD';
                break;
        }

        if (rate.hasOwnProperty(key)) {
            return rate[key];
        }

        return null;
    }
}
